import { PersistedState } from "runed";
import type { PoiDensity } from "./geo/poi-density/index.ts";

export type UserPreferences = {
  mapStyleId?: string;
  poiDensity?: PoiDensity;
};

// TODO: update key once final product name is decided
export const userPreferences = new PersistedState<UserPreferences>(
  "mymaps.preferences",
  {},
);
